export class DocTypeHandlers {
  private static keyMappings: { [key: string]: string } = {
    "INTERNAL_SALES_ORDER": "internal-sales-orders",
      "INTERNAL_CONSIGNEE_CONSIGNMENT": "internal-consignee-consignments",
      "INTERNAL_SUPPLIER_CONSIGNMENT_IN": "internal-supplier-consignments-in",
      "INTERNAL_SUPPLIER_CONSIGNMENT_OUT": "internal-supplier-consignments-out",
      "INTERNAL_CUSTOMER_CONSIGNMENT_IN": "internal-customer-consignments-in",
      "INTERNAL_CUSTOMER_CONSIGNMENT_OUT": "internal-customer-consignments-out",
      "INTERNAL_CONSIGNOR_CONSIGNMENT": "internal-consignor-consignments",
      "INTERNAL_OUTBOUND_DELIVERY_ORDER": "internal-outbound-delivery-orders",
      "INTERNAL_INBOUND_DELIVERY_ORDER": "internal-inbound-delivery-orders",
      "INTERNAL_PAYMENT_VOUCHER": "internal-payment-vouchers",
      "INTERNAL_PURCHASE_GOODS_RECEIVED_NOTE": "internal-purchase-goods-received-notes",
      "INTERNAL_PURCHASE_GOODS_ISSUED_NOTE": "internal-purchase-goods-issued-notes",
      "INTERNAL_PURCHASE_INVOICE": "internal-purchase-invoices",
      "INTERNAL_PURCHASE_ORDER": "internal-purchase-orders",
      "INTERNAL_JOB_ORDER": "internal-job-orders",
      "INTERNAL_PACKING_ORDER": "internal-packing-orders",
      "INTERNAL_PURCHASE_RETURN": "internal-purchase-returns",
      "INTERNAL_PURCHASE_REQUISITION": "internal-purchase-requisitions",
      "INTERNAL_RECEIPT_VOUCHER": "internal-receipt-vouchers",
      "INTERNAL_SALARY_PAYMENT_VOUCHER": "internal-salary-payment-vouchers",
      "INTERNAL_SALES_INVOICE": "internal-sales-invoices",
      "INTERNAL_SALES_RETURN": "internal-sales-returns",
      "INTERNAL_JOBSHEET": "internal-jobsheets",
      "INTERNAL_SALES_RMA": "internal-sales-rma",
      "CUSTOMER_PURCHASE_CREDIT_NOTE": "customer-purchase-credit-notes",
      "CUSTOMER_PURCHASE_DEBIT_NOTE": "customer-purchase-debit-notes",
      "CUSTOMER_PURCHASE_GOODS_RECEIVED_NOTE": "customer-purchase-goods-received-notes",
      "CUSTOMER_PURCHASE_GOODS_RETURNED_NOTE": "customer-purchase-goods-returned-notes",
      "CUSTOMER_PURCHASE_INVOICE": "customer-purchase-invoices",
      "CUSTOMER_PURCHASE_ORDER": "customer-purchase-orders",
      "EXTERNAL_SALES_CREDIT_NOTE": "external-sales-credit-notes",
      "EXTERNAL_SALES_DEBIT_NOTE": "external-sales-debit-notes",
      "EXTERNAL_SALES_INVOICE": "external-sales-invoices",
      "EXTERNAL_SALES_ORDER": "external-sales-orders",
      "EXTERNAL_SALES_RETURN": "external-sales-returns",
      "EXTERNAL_INBOUND_DELIVERY_NOTE": "external-inbound-delivery-notes",
      "EXTERNAL_OUTBOUND_DELIVERY_NOTE": "external-outbound-delivery-notes",
      "SUPPLIER_SALES_CREDIT_NOTE": "supplier-sales-credit-notes",
      "SUPPLIER_SALES_DEBIT_NOTE": "supplier-sales-debit-notes",
      "SUPPLIER_SALES_INVOICE": "supplier-sales-invoices",
      "SUPPLIER_SALES_ORDER": "supplier-sales-orders",
      "SUPPLIER_SALES_RETURN": "supplier-sales-returns",
      "SUPPLIER_INBOUND_DELIVERY_NOTE": "supplier-inbound-delivery-notes",
      "SUPPLIER_OUTBOUND_DELIVERY_NOTE": "supplier-outbound-delivery-notes",
      "CUSTOMER_HEALTH_RECORD": "customer-health-records",
      "INTERNAL_SHOPPING_CART": "internal-shopping-carts",
      "INTERNAL_STOCK_ADJUSTMENT": "internal-stock-adjustment",
      "INTERNAL_SALES_CREDIT_NOTE": "internal-sales-credit-notes",
      "INTERNAL_SALES_CONTRACT": "internal-sales-contracts",
      "INTERNAL_PURCHASE_CONTRACT": "internal-purchase-contracts",
      "INTERNAL_PURCHASE_CREDIT_NOTE": "internal-purchase-credit-notes",
      "INTERNAL_PURCHASE_DEBIT_NOTE": "internal-purchase-debit-notes",
      "INTERNAL_SALES_DEBIT_NOTE": "internal-sales-debit-notes",
      "INTERNAL_STOCK_ALLOCATION": "internal-stock-allocation",
      "INTERNAL_STOCK_TRANSFER_NOTE": "internal-stock-transfer-notes",
      "INTERNAL_SERVICE_CLAIM": "internal-custom-internal-service-claims",
      "INTERNAL_SERVICE_CLAIM_RETURN": "internal-custom-internal-service-claim-returns",
      "INTERNAL_TREATMENT_PROGRESS_RECORD": "internal-custom-internal-treatment-progress-records",
      "INTERNAL_BLANKET_PURCHASE_ORDER": "internal-custom-internal-blanket-purchase-orders",
      "CUSTOM_MS_ESD_ORDER": "custom-ms-esd-order",
      "TMPL_INTERNAL_SALES_INVOICE": "tmpl-internal-sales-invoices",
      "INTERNAL_OUTBOUND_STOCK_TRANSFER": "internal-outbound-stock-transfers",
      "INTERNAL_INBOUND_STOCK_TRANSFER": "internal-inbound-stock-transfers",
      "INTERNAL_SALES_QUOTATION": "internal-sales-quotations",
      "INTERNAL_PURCHASE_QUOTATION": "internal-purchase-quotations",
      "INTERNAL_SALES_CASHBILL": "internal-sales-cashbills",
      "INTERNAL_SALES_INQUIRY": "internal-sales-inquiries",
      "INTERNAL_SALES_GOODS_RECEIVED_NOTES": "internal-sales-goods-received-notes",
      "INTERNAL_SALES_GOODS_ISSUED_NOTES": "internal-sales-goods-issued-notes",
      "INTERNAL_SUPPLIER_RTV": "internal-supplier-rtv",
      "INTERNAL_SALES_PROFORMA_INVOICE": "internal-sales-proforma-invoices",
      "INTERNAL_GOODS_DISPATCH_NOTE": "internal-goods-dispatch-notes",
      "INTERNAL_GOODS_DELIVERY_NOTE": "internal-goods-delivery-notes",
      "INTERNAL_STOCK_REQUISITION": "internal-stock-requisition",
      "LOAN_STOCK_RECEIVED_NOTE": "loan-stock-received-notes",
      "LOAN_STOCK_ISSUED_NOTE": "loan-stock-issued-notes",
      "INTERNAL_PURCHASE_GRN_STOCK_IN": "internal_purchase_grn_stock_in",
      "INTERNAL_SALES_GRN_STOCK_IN": "internal_sales_grn_stock_in",
      "INTERNAL_SALES_GOODS_RECEIVED_NOTE": "internal_sales_goods_received_note",
      "INTERNAL_SALES_GIN_STOCK_OUT": "internal_sales_gin_stock_out",
      "INTERNAL_SALES_GOODS_ISSUED_NOTE": "internal_sales_goods_issued_note",
      "INTERNAL_PURCHASE_GIN_STOCK_OUT": "internal_purchase_gin_stock_out",
      "INTERNAL_PURCHASE_CONSIGNMENT_GRN": "internal_purchase_consignment_grn",
      "INTERNAL_PURCHASE_CONSIGNMENT_GIN": "internal_purchase_consignment_gin",
      "INTERNAL_PURCHASE_CONSIGNMENT_INVOICE": "internal_purchase_consignment_invoice",
      "INTERNAL_PURCHASE_CONSIGNMENT_RETURN": "internal_purchase_consignment_return",
      "INTERNAL_CONSIGNMENT_STOCK_ADJUSTMENT": "internal_consignment_stock_adjustment",
      "INTERNAL_PURCHASE_CONSIGNMENT_ORDER": "internal_purchase_consignment_orders",
      "INTERNAL_SALES_REFUND_NOTE": "internal-sales-refund-notes",
      "INTERNAL_PURCHASE_REFUND_NOTE": "internal-purchase-refund-notes",
      "INTERNAL_PURCHASE_SELF_BILLED_INVOICE": "internal-purchase-self-billed-invoices",
      "INTERNAL_PURCHASE_INVOICE_NO_STOCK_IN": "internal-purchase-invoice-no-stock-in",
      "INTERNAL_SALES_INVOICE_NO_STOCK_OUT": "internal-sales-invoice-no-stock-out",
      "INTERNAL_PURCHASE_TRADE_IN": "internal-purchase-trade-in",
      "INTERNAL_SALES_TRADE_IN": "internal-sales-trade-in"
  };

  static getDocURL(internalKey: string): string | undefined {
    return DocTypeHandlers.keyMappings[internalKey];
  }
}
